import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2805d1cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "V-IM 登录", -1))
const _hoisted_3 = { class: "login-code" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "el-row" }
const _hoisted_6 = { class: "el-col-12" }
const _hoisted_7 = { class: "el-col-12" }
const _hoisted_8 = { class: "text-right" }

import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import Auth from "@/api/Auth";
import { useUserStore } from "@/store/userStore";
import { useChatStore } from "@/store/chatStore";
import UserApi from "@/api/UserApi";
import { getCodeImg, login } from "@/api/Login";
import Top from "@/components/Top.vue";
import VimConfig from "@/config/VimConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();
const chatStore = useChatStore();

const form = reactive({
  name: "",
  password: "",
  code: "",
  uuid: "",
  host: VimConfig.host,
});

const submit = () => {
  const reg =
    /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (!reg.test(form.host)) {
    ElMessage.error("主机地址不对");
    return;
  }
  Auth.setIp(form.host);
  login(form.name, form.password, form.code, form.uuid)
    .then((res: any) => {
      Auth.setToken(res.token);
      return UserApi.currentUser();
    })
    .then((res) => {
      let user = res.data;
      userStore.storeUser(user.id, { name: user.name, avatar: user.avatar });
      userStore.setUser(user);
      chatStore.reloadChats();
      router.push("/index/chat");
    });
};

// 验证码开关
const captchaOnOff = ref(true);
const codeUrl = ref("");

const getCode = () => {
  getCodeImg().then((res: any) => {
    Auth.setIp(form.host);
    captchaOnOff.value =
      res.captchaOnOff === undefined ? true : res.captchaOnOff;
    if (captchaOnOff.value) {
      codeUrl.value = "data:image/gif;base64," + res.img;
      form.uuid = res.uuid;
    }
  });
};

/**
 * 刷新主机
 */
const flush = () => {
  Auth.setIp(form.host);
  getCode();
};
onMounted(() => {
  Auth.isLogin()
    .then((res) => {
      if (res) {
        router.push("/index/chat");
      }
    })
    .catch((err) => {
      console.error(err);
    });

  getCode();
  form.host = Auth.getIp();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Top),
    _createVNode(_component_el_form, {
      class: "login",
      ref: "formRef",
      model: form,
      "label-width": "60px"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_form_item, {
          label: "用户名",
          class: "item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "密码",
          class: "item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "password",
              modelValue: form.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (captchaOnOff.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "验证码",
              prop: "code",
              class: "item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.code,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.code) = $event)),
                  "auto-complete": "off",
                  placeholder: "验证码",
                  style: {"width":"63%"}
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: codeUrl.value,
                    onClick: getCode,
                    class: "login-code-img"
                  }, null, 8, _hoisted_4)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "主机",
          class: "item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.host,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.host) = $event)),
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (flush()))
            }, {
              append: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (flush()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("刷新")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "info",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push('/register')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("注册")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("登录")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, null, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})